module.exports = __webpack_public_path__ + "img/end-to-end-operations.d42edfdf.svg";